import React, { useEffect } from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { useJpdCrossJoinNudgeEligibility } from './eligibility/jpd-eligibility.tsx';
import { useConfluenceCrossJoinNudgeEligibility } from './eligibility/confluence-eligibility.tsx';

import { useJpdCrossJoinNudge } from './nudges/jpd-nudge.tsx';
import { useConfluenceCrossJoinNudge } from './nudges/confluence-nudge.tsx';

/**
 * CrossJoinNudges conditionally renders various prompts based on user and site context.
 * Rendering occurs in a side-effectful way as targeting and eligibility checks are made synchronously at runtime.
 */
export const CrossJoinNudges = () => {
	return (
		<JSErrorBoundary id="JiraCrossJoinNudges" teamName="groot" packageName="jiraCrossJoinNudges">
			<CrossJoinNudgesWithoutErrorBoundary />
		</JSErrorBoundary>
	);
};

/**
 * useCrossJoinNudges
 * @param execNudge is a temporary prop used to safely feature-gate the gate groot-1154-cjn-global-home
 * @deprecated use CrossJoinNudges instead
 */
export const useCrossJoinNudges = (execNudge = true) => {
	const getJpdCrossJoinNudgeEligibility = useJpdCrossJoinNudgeEligibility();
	const getConfluenceCrossJoinNudgeEligibility = useConfluenceCrossJoinNudgeEligibility();
	const showJpdNudge = useJpdCrossJoinNudge();
	const showConfluenceNudge = useConfluenceCrossJoinNudge();
	useEffect(() => {
		async function executeNudges() {
			const jpdEligibilityResult = await getJpdCrossJoinNudgeEligibility();
			if (jpdEligibilityResult.isEligible) {
				showJpdNudge();
				return;
			}
			const confluenceEligibilityResult = await getConfluenceCrossJoinNudgeEligibility();
			if (confluenceEligibilityResult.isEligible) {
				showConfluenceNudge(confluenceEligibilityResult.data);
			}
		}
		if (execNudge) {
			executeNudges();
		}
	}, [
		getJpdCrossJoinNudgeEligibility,
		getConfluenceCrossJoinNudgeEligibility,
		showJpdNudge,
		showConfluenceNudge,
		execNudge,
	]);
};

const CrossJoinNudgesWithoutErrorBoundary = () => {
	useCrossJoinNudges(true);

	return null;
};

export default CrossJoinNudges;
